export default "__VITE_ASSET__D_pCTccq__"